// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_wishlist
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddToWishListItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackAddToWishListParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackAddToWishListItem> {}

const trackAddToWishList = (parameters: TrackAddToWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "add_to_wishlist", ...parameters }, { ...options, skipItemIndex: true });
};

export default trackAddToWishList;
